/**
 * Yields control to the main thread to prevent UI freezing.
 */
export const yieldToMain = () => new Promise(resolve => setTimeout(resolve, 0));

/**
 * Updates the CSS progress bar property.
 * @param {number} percent 
 */
export function updateProgress(percent) {
    const mainTopRow = document.querySelector('.main-top-row');
    if (mainTopRow) {
        mainTopRow.style.setProperty('--progress', `${percent}%`);
    }
}

/**
 * Calculates the frequency of a piano key (1-88).
 * @param {number} n key number
 * @returns {number} frequency in Hz
 */
export const getPianoFrequency = (n) => 440 * Math.pow(2, (n - 49) / 12);

/**
 * Detects the Screen's Pixels Per Inch (PPI).
 * @returns {number}
 */
export function getPPI() {
    const div = document.createElement("div");
    div.style.width = "1in";
    div.style.height = "1in";
    div.style.position = "absolute";
    div.style.left = "-100in";
    div.style.top = "-100in";
    div.style.visibility = "hidden";
    document.body.appendChild(div);
    const ppi = div.offsetWidth;
    document.body.removeChild(div);
    return ppi || 96; // Fallback to 96
}

/**
 * Converts a UI slider position (-12 to +12, with 0 at visual center) to filter gain in dB (-24 to +12).
 * @param {number|string} val UI slider position (-12 to +12).
 * @return {number} Gain in dB (-24 to +12).
 */
export function sliderValueToDb(val) {
    const v = parseFloat(val);
    if (isNaN(v)) return 0;
    if (v >= 0) return v;
    return v * 2;
}

/**
 * Converts filter gain in dB (-24 to +12) to UI slider position (-12 to +12, with 0 at visual center).
 * @param {number|string} db Gain in dB (-24 to +12).
 * @return {number} UI slider position (-12 to +12).
 */
export function dbToSliderValue(db) {
    const d = parseFloat(db);
    if (isNaN(d)) return 0;
    if (d >= 0) return d;
    return Math.max(-12, d / 2);
}

/**
 * Determines whether a DOM element is an active text-editing input.
 * Non-text inputs (like range sliders, checkboxes, buttons) return false.
 * @param {Element|EventTarget|null} el The element to check.
 * @return {boolean} True if the element accepts text editing.
 */
export function isTextEditable(el) {
    if (!el || typeof el !== 'object' || el.nodeType !== 1) return false;
    if (el.isContentEditable) return true;
    const tag = el.tagName;
    if (tag === 'TEXTAREA') return true;
    if (tag === 'INPUT') {
        const type = (el.type || 'text').toLowerCase();
        const nonTextTypes = ['range', 'checkbox', 'radio', 'button', 'submit', 'reset', 'file', 'color', 'image'];
        return !nonTextTypes.includes(type);
    }
    return false;
}


